import React from "react";
import {
  ContactContent,
  ContactSection,
  ContactSubtitle,
  Contacttitle,
  Container,
  Form,
  Information,
  Input,
  InputsWrapper,
  Label,
  SubmitBtn,
  Subtitle,
  TextArea,
  Title,
} from "./ContactStyles";
import {
  UilPhone,
  UilEnvelope,
  UilMapMarker,
  UilMessage,
} from "@iconscout/react-unicons";
import { useRef } from "react";
import emailjs from "emailjs-com";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from "react";

toast.configure();

const ContactData = [
  {
    title: "Call Me",
    icon: <UilPhone className="contact-icon" size="2rem" />,
    contactLink: "+234 80 3313 0603",
  },
  {
    title: "Email",
    icon: <UilEnvelope className="contact-icon" size="2rem" />,
    contactLink: "ojiinnocent@gmail.com",
  },
  {
    title: "Location",
    icon: <UilMapMarker className="contact-icon" size="2rem" />,
    contactLink:
      "Rework Technologies, house 5, Block 3, Aknaton estate, Durumi-Abuja, Nigeria",
  },
];

const Contact = () => {
  var formRef = useRef();
  const [formSent, setFormsent] = useState(false);

  const notify =()=>{
    toast.success('Thank you for contacting us, we will get back to you shortly.',
    {position: toast.POSITION.TOP_CENTER, autoClose:8000})
  }

  const sendEmail = (e) => {
    e.preventDefault();
    setFormsent(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        (result) => {
          formRef.current.reset();//clear the input fields
          notify();
          setFormsent(false);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  

  return (
    <ContactSection className="contact-section">
      <Title>Contact Me</Title>
      <Subtitle>Get in touch</Subtitle>

      <Container>
        <div>
          {ContactData.map((data, index) => (
            <Information key={index}>
              <div className="icon-wrapper">{data.icon}</div>
              <div>
                <Contacttitle>{data.title}</Contacttitle>
                <ContactSubtitle>{data.contactLink}</ContactSubtitle>
              </div>
            </Information>
          ))}
        </div>

        <Form ref={formRef} onSubmit={sendEmail}>
          <InputsWrapper>
            <ContactContent>
              <Label htmlFor="">Name</Label>
              <Input type="text" name="user_name" />
            </ContactContent>
            <ContactContent>
              <Label htmlFor="">Email</Label>
              <Input type="email" name="user_email" />
            </ContactContent>
          </InputsWrapper>
          <ContactContent>
            <Label htmlFor="">Project</Label>
            <Input type="text" name="project" />
          </ContactContent>
          <ContactContent>
            <Label htmlFor="">Message</Label>
            <TextArea name="message" cols="0" rows="7" name="message" />
          </ContactContent>
          <div>
            <SubmitBtn type="submit" value="Send" disabled={formSent}>
              Send Message
              <UilMessage className="btn__icon" />
            </SubmitBtn>
          </div>
        </Form>
      </Container>
    </ContactSection>
  );
};

export default Contact;
